import React, { useEffect, useRef, useState } from "react"
import { ChevronDown, Check } from "lucide-react"

/**
 * Dark-themed replacement for a native <select>. A plain <select>'s dropdown
 * list is rendered by the OS/browser and ignores the page's dark theme
 * entirely (light background, blue highlight) - this renders its own menu
 * so it always matches the rest of the UI.
 */
const SortDropdown = ({ value, options, onChange }) => {
    const [open, setOpen] = useState(false)
    const containerRef = useRef(null)

    useEffect(() => {
        if (!open) return
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false)
        }
        const handleKeyDown = (e) => { if (e.key === "Escape") setOpen(false) }
        document.addEventListener("mousedown", handleClickOutside)
        document.addEventListener("keydown", handleKeyDown)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
            document.removeEventListener("keydown", handleKeyDown)
        }
    }, [open])

    const current = options.find(opt => opt.value === value) || options[0]

    return (
        <div ref={containerRef} style={{ position: "relative" }}>
            <button
                type="button"
                onClick={() => setOpen(o => !o)}
                className="influencer-select-trigger"
                aria-haspopup="listbox"
                aria-expanded={open}
            >
                {current?.label}
                <ChevronDown size={14} style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform 0.15s ease" }} />
            </button>

            {open && (
                <div className="influencer-select-menu" role="listbox">
                    {options.map(opt => (
                        <div
                            key={opt.value}
                            role="option"
                            aria-selected={opt.value === value}
                            onClick={() => { onChange(opt.value); setOpen(false) }}
                            className={`influencer-select-option${opt.value === value ? " is-active" : ""}`}
                        >
                            <span>{opt.label}</span>
                            {opt.value === value && <Check size={14} color="#F6255A" />}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default SortDropdown
